import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography, TextField , Box  } from "@mui/material";
import {EditOutlined ,DeleteOutline } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useSelector , useDispatch } from "react-redux";
import _ from "lodash";
import { useFormik } from "formik";
import Pagination from "@mui/material/Pagination";

//Services
import Bannerapi from "Services/Bannermanage";

//Modals
import BannerAddModal from "Pages/Modals/BannerManagement/Create";
import BannerUpdateModal from "Pages/Modals/BannerManagement/Update";
import BannerDeleteDialog from "Pages/Modals/BannerManagement/Delete";

const BannerTemplateManage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  //

  const [row, setRow] = useState([]);
  const [customerId, setCustomerId] = useState("");

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);

  //Modals

  const [addBannerModal, setaddBannerModal] = useState(false);

  const  handleOpenAddBannerModal = () => {
    setaddBannerModal(true);
  };

  const handleCloseBannerModal = () => {
    setaddBannerModal(false);
    getBanner();
  };

  const [updateBannerModal, setupdateBannerModal] = useState(false);

  const handleOpenUpdateBannerModal = (row) => {
    //console.log('service update data -->',row);
    setCustomerId(row?._id);
    setupdateBannerModal(true);
  };

  const handleCloseUpdateBannerModal = () => {
    setupdateBannerModal(false);
    getBanner();
  };
  
  const [deleteBannerModal, setdeleteBannerModal] = useState(false);

  const handleOpenDeleteBannerModal = (row) => {
    setCustomerId(row?._id);
    setdeleteBannerModal(true);
  };

  const handleCloseDeleteBannerModal = (row) => {
    setdeleteBannerModal(false);
    getBanner();
  };

  // Get Services list api
  const getBanner = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      //console.log('res.data--->',res.data);
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    Bannerapi.getBannerList({ page, limit: pageSize })
      .then(onSuccess, onFailure);
  }, [page, pageSize]);

  useEffect(() => {
    getBanner();
  }, [getBanner]);


  const handleCopy = () => {

       // Define column widths
       const columnWidths = [5, 15 ]; // Adjust widths as needed
  
       // Helper function to pad text to the desired width
       const padText = (text, width) => {
         return (text ?? "").toString().padEnd(width, " ");
       };
       // Create table header
       const header = [
         padText("S.NO", columnWidths[0]),
         padText("SERVICE NAME", columnWidths[1]),
       ].join("");
     
       // Create table rows
       const rows = dataRows
         .map((row) =>
           [
             padText(row.sno, columnWidths[0]),
             padText(row.BannerName, columnWidths[1]),
           ].join("")
         )
         .join("\n");
     
       // Combine header and rows
       const formattedContent = [header, rows].join("\n");
     
       // Copy to clipboard
       navigator.clipboard.writeText(formattedContent).then(() => {
         alert("Table copied to clipboard!");
       });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "ServiceList.xlsx");
  };

  const handleDownloadCSV = () => {
    const csv = Papa.unparse(formatteddatas);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "ServiceList.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.BannerName,
    ]);
    doc.autoTable({
      head: [["S.No", "Service Name"]],
      body: tableData,
    });
    doc.save("ServiceList.pdf");
  };

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    BannerName: data?.BannerName,
    BannerImage: data?.BannerImage,
    row: data,
  }));

  // console.log(dataRows)
  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Banner Name": row.BannerName,
  }));
  
  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "BannerName",
      headerName: "Banner Name",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.BannerName}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "BannerImage",
      headerName: "Banner",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
<div>
                  <Box
                  component="img"
                  sx={{
                  width: 50,
                  height: 50,
                  borderRadius: "25%",
                  objectFit: "cover",
                  boxShadow: 3,
                  }}
                  src={params?.row?.BannerImage}
                  alt="Sample Image"
                  />
</div>
          </>
        );
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex:1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.iconsWrapper}>
              <section className={classes.editIcon}>
                <EditOutlined
                  onClick={() =>
                    handleOpenUpdateBannerModal(params?.row?.row)
                  }
                />
                  <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Edit
                   </Typography>
              </section>
              <section className={classes.deleteIcon}>
                <DeleteOutline
                  onClick={() =>
                    handleOpenDeleteBannerModal(params?.row?.row)
                  }
                />
                <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Delete
                   </Typography>
              </section>
            </div>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
      {/* <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid> */}
        <Grid item xs={8} md={8} lg={8} xl={8} className={classes.funBtn}>
          <Button variant="contained" onClick={ handleOpenAddBannerModal}>
            Add New Banner
          </Button>
        </Grid>
        <Grid item xs={12} >
          <section  className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
              columnResizeMode="onDrag" // Allows resizing
            />
          </section>
        </Grid>
      </Grid>
      <BannerAddModal
        openDialog={addBannerModal}
        handleClose={handleCloseBannerModal}
      ></BannerAddModal>
      <BannerUpdateModal
        openDialog={updateBannerModal}
        id={customerId}
        handleClose={handleCloseUpdateBannerModal}
      ></BannerUpdateModal>
      <BannerDeleteDialog
        openDialog={deleteBannerModal}
        id={customerId}
        handleClose={handleCloseDeleteBannerModal}
      ></BannerDeleteDialog>
    </>
  );
};

export default BannerTemplateManage;
